
import React from 'react';
import { Route } from '../types';

interface RouteTableProps {
  routes: Route[];
}

const RouteTable: React.FC<RouteTableProps> = ({ routes }) => {
  return (
    <div className="flex-1 overflow-auto">
      <table className="w-full text-[11px] text-left whitespace-nowrap" style={{ color: 'var(--ih-theme-text-tertiary)' }}>
        <thead className="text-[10px] uppercase sticky top-0 z-10" style={{ backgroundColor: 'var(--ih-theme-bg-elevated)', color: 'var(--ih-theme-text-tertiary)', borderBottomWidth: '1px', borderColor: 'var(--ih-theme-border-light)' }}>
          <tr>
            <th className="px-3 py-3 font-bold">Pickup</th>
            <th className="px-3 py-3 font-bold">Load Details</th>
            <th className="px-3 py-3 font-bold">Origin WH</th>
            <th className="px-3 py-3 font-bold">Origin City</th>
            <th className="px-3 py-3 font-bold">Dest WH</th>
            <th className="px-3 py-3 font-bold">Dest City</th>
            {/* <th className="px-3 py-3 font-bold">Units</th> */}
            <th className="px-3 py-3 font-bold">Activity</th>
            <th className="px-3 py-3 font-bold">Tonnage (T)</th>
            <th className="px-3 py-3 font-bold">Volume (ft³)</th>
            {/* <th className="px-3 py-3 font-bold">Dist (mi)</th> */}
            <th className="px-3 py-3 font-bold">Delivery</th>
          </tr>
        </thead>
        <tbody style={{ borderColor: 'var(--ih-theme-border-light)' }}>
          {routes.map((route, idx) => (
            <tr key={idx} className="transition-colors group" style={{ borderBottomWidth: '1px', borderColor: 'var(--ih-theme-border-light)' }} onMouseEnter={e => (e.currentTarget.style.backgroundColor = 'rgba(59, 130, 246, 0.05)')} onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}>
              <td className="px-3 py-3" style={{ fontFamily: 'var(--ih-font-family-mono)', color: 'var(--ih-theme-text-primary)' }}>{route.pickupDate}</td>
              <td className="px-3 py-3">
                <div className="flex flex-col gap-1">
                  {route.productId.map((p, i) => (
                    <span key={i} className="inline-flex items-center gap-1.5 text-[10px]">
                      <span className="font-semibold" style={{ color: 'var(--ih-theme-accent-light)' }}>{p.customerLoadId}</span>
                      <span style={{ color: 'var(--ih-theme-text-muted)' }}>×</span>
                      <span className="font-bold" style={{ color: 'var(--ih-theme-text-primary)' }}>{p.count}</span>
                    </span>
                  ))}
                </div>
              </td>
              <td className="px-3 py-3" style={{ color: 'var(--ih-theme-text-muted)', fontFamily: 'var(--ih-font-family-mono)' }}>{route.sourceCustomerWarehouseId}</td>
              <td className="px-3 py-3" style={{ color: 'var(--ih-theme-text-primary)' }}>{route.sourcePredictedCity}</td>
              <td className="px-3 py-3" style={{ color: 'var(--ih-theme-text-muted)', fontFamily: 'var(--ih-font-family-mono)' }}>{route.destinationCustomerWarehouseId}</td>
              <td className="px-3 py-3" style={{ color: 'var(--ih-theme-text-primary)' }}>{route.destinationPredictedCity}</td>
              {/* <td className="px-3 py-3 font-bold" style={{ color: 'var(--ih-theme-text-primary)' }}>{route.units}</td> */}
              <td className="px-3 py-3">
                <span className="px-1.5 py-0.5 rounded text-[9px] font-bold" style={{
                  backgroundColor: route.activity === 'Load' ? 'rgba(59, 130, 246, 0.15)' : 'var(--ih-theme-bg-elevated)',
                  color: route.activity === 'Load' ? 'var(--ih-theme-accent-light)' : 'var(--ih-theme-text-tertiary)'
                }}>
                  {route.activity}
                </span>
              </td>
              <td className="px-3 py-3" style={{ fontFamily: 'var(--ih-font-family-mono)', color: 'var(--ih-theme-text-secondary)' }}>{route.tonnage.toFixed(3)}</td>
              <td className="px-3 py-3" style={{ fontFamily: 'var(--ih-font-family-mono)', color: 'var(--ih-theme-text-secondary)' }}>{route.volume.toFixed(2)}</td>
              {/* <td className="px-3 py-3 font-bold" style={{ color: 'var(--ih-theme-text-primary)' }}>{route.distance.toFixed(2)}</td> */}
              <td className="px-3 py-3" style={{ fontFamily: 'var(--ih-font-family-mono)', color: 'var(--ih-theme-text-muted)' }}>{route.deliveryDate}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RouteTable;
